import Vue from 'vue'
import { addGA } from '@/utils/assist'
import { updateConsentGA } from '@/utils/eu_popup'

export default new Vue({
  data () {
    return {
      uid: null,
      gems: 0,
      discount: 1, // 折扣
      price: 0, // 当前价格
      allPrice: 0, // 总价格
      actInfo: {
        freeUsedTimes: 0,
        freeAllTimes: 0,
        refreshStatus: false, // 下次刷新是否需要支付钻石
        refreshCost: 0,
        discounts: [],
        endTime: 0
      },
      toast: {
        show: false,
        isMsg: false,
        text: ''
      },
      loading: { // loading dialog
        show: false,
        opacity: false
      },
      rule: { // rule dialog
        show: false,
        content: ''
      },
      history: { // history dialog
        show: false,
        data: [] // history 相关数据
      },
      buy: { // 购买确认弹窗
        show: false
      },
      refreshDialog: {
        show: false,
        status: 0 // 0 -> 免费刷新 / 1 -> 付费刷新
      },
      ComPool: { // 当前商品池
        status: status,
        list: []
      },
      selects: [], // 已选择商品
      hasToken: false,
      transify: {
        COMMON_BACK: 'back',
        COMMON_CANCEL: 'cancel',
        COMMON_CONFIRM: 'confirm',
        COMMON_CONTINUE_PURCHASE: 'continue to buy',
        COMMON_HISTORY_DRAW: '',
        COMMON_HISTORY_PURCHASE: '',
        COMMON_HISTORY_REDEEM: '',
        COMMON_NO: 'no',
        COMMON_PURCHASE: 'purchase',
        COMMON_PURCHASED: 'purchased',
        COMMON_QUANTITY_MAX: 'max',
        COMMON_TIPS_ITEM: 'the rewards will be sent directly to your vault',
        COMMON_YES: 'Yes',
        POPUP_NO_REMIND: '', // 需要默认值
        POPUP_TITLE_REDEEM: 'Congratulation! You got',
        POPUP_TITLE_UNIQUE: 'The unique items you owe',
        UNIQUE_BUY_ALREADY_HAVE:
          'You already own this item, if you purchase it again, it will be converted to FF tokens.',
        UNIQUE_BUY_ALREADY_HAVE_PART:
          'You already owe some of the item(s) you selected. If you purchase again, you will receive FF tokens instead.',
        UNIQUE_REDEEM_ALREADY_HAVE:
          'You already own this item, if you receive it again, it will be converted to FF tokens.',
        TOAST_ERROR_CODE: 'unknown error, error code {code}',
        TOAST_EVENT_CLOSED_AWHILE: 'The event is closed temporary',
        TOAST_EVENT_END: 'Event ended',
        TOAST_EVENT_NOTOPEN: "event hasn't started",
        TOAST_GEM_NOT_ENOUGH: 'insufficient diamonds, please top up and come back again',
        TOAST_LOGIN_FAILED: 'login failed',
        TOAST_NETWORK_BUSY: 'Server busy, please try again later',
        TOAST_NETWORK_ERROR: 'Network connection error, please try again later',
        TOAST_OPERATE_BUSY: 'Too many requests, please try again later',
        TOAST_PAY_FAILED: 'purchase failed',
        TOAST_SERVER_BUSY: '',
        TOAST_SERVER_NOTWORK: 'service unavailable',
        TOAST_SERVER_TIMEOUT: 'service timeout',
        TOAST_WRONG_REGION: 'This event is not available for your region'
      }
    }
  },
  methods: {
    updateConsentGA,
    addGA (event, msg) { // google 统计
      addGA(event, msg)
    },
    checkGem (price) {
      let flag = true
      if (this.gems < price) {
        flag = false
      }
      return flag
    },
    /**
     * 错误处理
     * @param {String} errCode 错误码
     * @return toast | dialog 组件
     */
    handleError (errCode) {
      // TODO 错误信息提示窗
      this.handleToast(true, errCode, true)
      addGA('msgError', errCode)
    },
    handleToast (bool, text, isMsg = false) { // toast
      this.toast.show = bool
      this.toast.text = this.transify[text] || this.transify['TOAST_NETWORK_ERROR']
      this.toast.isMsg = isMsg
    },
    handleLoading (bool, opacity, delay) { // loading
      if (bool === true) {
        this.loading.opacity = opacity
        this.loading.show = bool
      } else {
        setTimeout(() => {
          this.loading.show = bool
          this.loading.opacity = opacity
        }, delay)
      }
    },
    // 设置商品池
    setComPool (source, status = false) { // source api返回的pool, status => buy true or buy false
      this.ComPool.status = status
      this.ComPool.list = []
      for (let item of source) {
        this.ComPool.list.push({
          id: item.reward_id, // 商品id
          name: item.item_name, // 商品
          nums: item.item_num, // 商品数
          thumb: item.item_img, // 商品缩略图链接
          src: item.item_big_img, // 商品图链接
          status: item.bought, // buy true or buy false single item
          price: item.price,
          isToken: item.is_token // is unique and have
        })
        // 设置selects
        this.setInitSelects(item)
      }
    },
    // 设置selects
    setInitSelects (item) {
      if (item.bought) {
        this.selects.push({
          id: item.reward_id, // 商品id
          name: item.item_name, // 商品
          nums: item.item_num, // 商品数
          thumb: item.item_img, // 商品缩略图链接
          src: item.item_big_img, // 商品图链接
          status: item.bought, // buy true or buy false single item
          price: item.price,
          isToken: item.is_token // is unique and have
        })
      }
    },
    // 刷新商品池
    refresh (status) {
      let cost
      status === 0 ? cost = 0 : cost = this.actInfo.refreshCost
      this.$api.refresh({cost: cost}).then(res => {
        let [pool, history] = [res.data.pool, res.data.history]
        status === 0 ? this.$bus.actInfo.freeUsedTimes++ : this.$bus.actInfo.payUsedTimes++
        this.gems -= cost
        this.selects = [] // 清空选项
        this.setComPool(pool, false) // 设置奖池
        this.history.data.push(history)// 设置history
        this.refreshDialog.show = false
        this.handleToast(true, 'T_KU_REFRESH_SUCCESS') // 提示刷新成功
      })
    },
    purchase () {
      const ids = []
      for (let item of this.selects) {
        ids.push(item.id)
      }
      this.$api.buy({cost: this.price, reward_ids: ids}).then(res => {
        let history = res.data.history
        this.history.data.push(history)// 设置history
        this.ComPool.status = true
        this.gems -= this.price
        this.buy.show = false
        this.handleToast(true, 'T_KU_PURCHASE_SUCCESS')
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/bus/index.js